import { NavLink } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import Modal from '../../../shared/modal';
import { INotificationBody } from '../../../interfaces/staff/notifications/INotifications';
import { openChat } from '../../../store/brokers/partners/chats/ChatsUISlice';
import { useReadNotificationMutation } from '../../../store/trips/tripsApi';
import Button from '../../../shared/button';
import { useChatboxMutation } from '../../../store/chatbox/chatboxApi';
import { useState } from 'react';

const NotificationsModal = ({ open, onClose, notifications, tripId, admin, setPage, page, hasMore, isLoadingNotifications, onOpenHodReport, onOpenTmReport }: { 
	open: boolean, 
	onClose: () => void, 
	notifications: INotificationBody[], 
	tripId?: string, 
	admin?: boolean 
	setPage?: (page: number) => void;
	page?: number;
	hasMore?: boolean;
	isLoadingNotifications?: boolean;
	onOpenHodReport?: (tripId: string, reportType: 'cabin' | 'bar' | 'restaurant') => void;
	onOpenTmReport?: (tripId: string) => void;
}) => {
	const dispatch = useAppDispatch()
	const [chatBoxAdd] = useChatboxMutation();
	const [readNotification] = useReadNotificationMutation();
	const [hideNotifications, setHideNotifications] = useState<any>([])

	const handleReadNotification = async (id: string, tripId: string, feedbackId: string, action: string) => {
		try {
			// await chatBoxAdd({ tripId, message: 'Acknowledge', feedbackId, action }).unwrap();
			readNotification(id).unwrap();
		} catch (e) {
		}

	}

	const acknowledgeNotificationsHandle = async (id: string, tripId: string, feedbackId: string, action: string) => {
		try {
			await chatBoxAdd({ tripId, message: 'Acknowledge', feedbackId, action }).unwrap();
			readNotification(id).unwrap();
			setHideNotifications((prev: any) => [...prev || [], id])
		} catch (e) {
		}
	}

	const getRelativeTime = (isoDate: string): string => {
		const date = new Date(isoDate);
		const now = new Date();
		const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

		if (diffInSeconds < 60) {
			return `${diffInSeconds} sec ago`;
		}

		const diffInMinutes = Math.floor(diffInSeconds / 60);
		if (diffInMinutes < 60) {
			return `${diffInMinutes} min ago`;
		}

		const diffInHours = Math.floor(diffInMinutes / 60);
		if (diffInHours < 24) {
			return `${diffInHours} hr ago`;
		}

		const diffInDays = Math.floor(diffInHours / 24);
		return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
	}

	const onClickAdminOpenChat = async (tripId: string, type?: string, feedbackId?: string) => {
		try {
			dispatch(openChat({
				tripId: tripId,
				action: type,
				feedbackId: feedbackId,
				data: []
			}));
		} catch (err) {
			console.error(err);
		}
	}

	const handleLoadMore = () => {
		if ((!hasMore || isLoadingNotifications) && !page && !setPage) return;
		const nextPage = Number(page) + 1;
		setPage?.(nextPage);
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
			contentContainerStyle='max-w-[95%] w-[500px] rounded-lg mb-4'
			title='Your Notifications'
		>
			<div className='md:w-[450px]'>
				{!(notifications && notifications?.length > 0 && notifications?.filter((item: any) => !hideNotifications?.includes(item?._id))?.length > 0) &&
					<div className='my-4 text-center'>
						<p className='text-primary-light'>No new notifications</p>
					</div>
				}

				<div className='mt-4 h-[600px] overflow-auto' style={{ overflowAnchor: 'none' }}>
					{notifications && notifications?.length > 0 && notifications?.filter((item: any) => !hideNotifications?.includes(item?._id))?.map(notification => (
						<div key={notification._id} className='bg-gray-50 border border-gray-200 dark:border-[#252B37] dark:bg-[#252B37] rounded-lg p-4 mb-3 text-center'>
							<h3 className='text-base font-bold text-gray-800'>Notifications - {getRelativeTime(notification.updatedAt)}</h3>
							<p className='text-sm text-gray-500 dark:text-white'>From <b>{notification.meta?.guestName || 'staff'}</b> on <b>{notification.cabinId}</b></p>
							<div className='text-sm text-gray-900 dark:text-white mt-4'>
								{'"'}{notification.meta?.feedback}{'"'}
							</div>
						{!admin && notification?.type === 'hod-report-ready' && onOpenHodReport &&
							<div className='flex flex-row justify-center'>
								<div
									onClick={() => {
										handleReadNotification(notification._id, notification?.tripId || tripId || '', '', notification.type || '');
										onOpenHodReport(notification?.tripId || tripId || '', notification?.meta?.reportType || 'cabin');
										onClose();
									}}
									className='mt-4 bg-primary-default hover:bg-opacity-80 text-white p-2.5 rounded-3xl block text-sm font-normal text-center cursor-pointer'>
									Review Report
								</div>
							</div>
						}
						{!admin && notification?.type === 'tm-report-ready' && onOpenTmReport &&
							<div className='flex flex-row justify-center'>
								<div
									onClick={() => {
										handleReadNotification(notification._id, notification?.tripId || tripId || '', '', notification.type || '');
										onOpenTmReport(notification?.tripId || tripId || '');
										onClose();
									}}
									className='mt-4 bg-primary-default hover:bg-opacity-80 text-white p-2.5 rounded-3xl block text-sm font-normal text-center cursor-pointer'>
									Review Report
								</div>
							</div>
						}
						{!admin && notification?.type !== 'hod-report-ready' && notification?.type !== 'tm-report-ready' &&
							<>
								{(notification?.type !== 'feedback-alert') ?
									<NavLink
										className='mt-4 bg-primary-default hover:bg-opacity-80 text-white p-2.5 rounded-3xl block text-sm font-normal text-center cursor-pointer'
										onClick={() => handleReadNotification(notification._id, tripId || '', notification?.feedbackId || '', notification.type || '')}
										to={notification?.type ?
											notification?.feedbackId ?
												`/staff/chat/${tripId}?type=${notification?.type}&feedbackId=${notification?.feedbackId}`
												: `/staff/chat/${tripId}?type=${notification?.type}`
											: `/staff/chat/${tripId}`}
									>
										Acknowledge
									</NavLink> :
									<div className='flex flex-row justify-center'>
										<div
											onClick={() => acknowledgeNotificationsHandle(notification._id, tripId || '', notification?.feedbackId || '', notification.type || '')}
											className='mt-4 bg-primary-default hover:bg-opacity-80 text-white p-2.5 rounded-3xl block text-sm font-normal text-center cursor-pointer'>
											Acknowledge
										</div>
									</div>
								}
							</>
						}
						{admin && notification?.type === 'hod-report-ready' && onOpenHodReport &&
							<div className='flex flex-row justify-center'>
								<Button
									label={'Review Report'}
									className='mt-4 btn-primary-rounded-less dark:!bg-black'
									onClickButton={() => {
										handleReadNotification(notification._id, notification?.tripId || '', '', notification.type || '');
										onOpenHodReport(notification?.tripId || '', notification?.meta?.reportType || 'cabin');
										onClose();
									}}
								/>
							</div>
						}
						{admin && notification?.type === 'tm-report-ready' && onOpenTmReport &&
							<div className='flex flex-row justify-center'>
								<Button
									label={'Review Report'}
									className='mt-4 btn-primary-rounded-less dark:!bg-black'
									onClickButton={() => {
										handleReadNotification(notification._id, notification?.tripId || '', '', notification.type || '');
										onOpenTmReport(notification?.tripId || '');
										onClose();
									}}
								/>
							</div>
						}
						{admin && notification?.type !== 'report-ready' && notification?.type !== 'hod-report-ready' && notification?.type !== 'tm-report-ready' &&
							<div className='flex flex-row justify-center'>
								{notification?.type === 'feedback-alert' ?
									<Button
										label={'Acknowledge'}
										onClickButton={() => acknowledgeNotificationsHandle(notification._id, notification?.tripId || '', notification?.feedbackId || '', notification.type || '')}
										className='mt-4 btn-primary-rounded-less dark:!bg-black'
									/> :
									<Button
										label={'Reply'}
										className='mt-4 btn-primary-rounded-less dark:!bg-black'
										onClickButton={() => onClickAdminOpenChat(notification?.tripId || '', notification?.type, notification?.feedbackId)}
									/>
								}
							</div>
						}
						</div>
					))}
									{
					hasMore && !isLoadingNotifications ? (
						<div className="flex justify-center mt-3">
							<button
								className="bg-primary-default hover:bg-primary-default/80 text-white font-semibold py-2 px-4 rounded-md"
								onClick={handleLoadMore}
							>
								Load More Notifications
							</button>
						</div>
					) : isLoadingNotifications && (
						<div className="flex justify-center my-3">
							<div className="w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
						</div>
					)
				}
				</div>
			</div>
		</Modal >
	)
}

export default NotificationsModal;